module.exports = __webpack_public_path__ + "media/images/pic/brodno/offer/map-340c31bb4b9d493bb244153dd1a5e140.jpg";